(function(){
  'use strict';
  // menu mobile
  var b=document.getElementById('burger'), m=document.getElementById('mnav'), mc=document.getElementById('mclose');
  if(b&&m){ b.addEventListener('click',function(){m.classList.add('open');}); }
  if(mc&&m){ mc.addEventListener('click',function(){m.classList.remove('open');}); }
  // reveals
  var els=document.querySelectorAll('.reveal');
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.12});
    els.forEach(function(el){io.observe(el);});
  } else { els.forEach(function(el){el.classList.add('in');}); }
  // compteurs
  var reduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function countUp(el){
    if(el.dataset.done)return; el.dataset.done='1';
    var t=parseFloat((el.getAttribute('data-count')||'0').replace(',','.'))||0;
    var u=el.querySelector('.u');
    function render(v){el.innerHTML=Math.round(v)+(u?u.outerHTML:'');}
    if(reduced){render(t);return;}
    var s=null; function fr(ts){if(!s)s=ts;var p=Math.min((ts-s)/1400,1);render((1-Math.pow(1-p,3))*t);if(p<1)requestAnimationFrame(fr);} requestAnimationFrame(fr);
  }
  var cs=document.querySelectorAll('[data-count]');
  if('IntersectionObserver' in window){
    var io2=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){countUp(e.target);io2.unobserve(e.target);}});},{threshold:.4});
    cs.forEach(function(el){io2.observe(el);});
  } else { cs.forEach(countUp); }
  // toast
  window.lvToast=function(msg){var t=document.getElementById('toast');if(!t)return;t.textContent=msg;t.classList.add('show');setTimeout(function(){t.classList.remove('show');},2200);};
})();